import React from 'react';
import { RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { KeepInTouchProps } from './types/subscriptionBox.types';
import { KeepInTouchModel } from './models/subscriptionBox.model';
import LazySection from '../@shared/lazySection';
import Icon from '../@shared/icon';
import CustomExternalAnchor from '../@shared/customExternalAnchor';
import { EditFrameComponent } from '../@shared/editFrame';
import fields from '../../constants/fields.const';
import { iconSize } from '../../constants/icon.constants';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const SubscriptionBox = (props: KeepInTouchProps): JSX.Element => {
  const model = new KeepInTouchModel(props);
  const socialText = model.showForm?.value
    ? 'subscription-box__social__text subscription-box__social__text--with-form'
    : 'subscription-box__social__text';

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <LazySection>
      <div className="subscription-box-wrapper">
        <div className="subscription-box-wrapper__content">
          <div className="subscription-box pfe-l-grid pfe-m-gutters pfe-m-all-6-col-on-md">
            <div className="subscription-box__content">
              {model.title && <Text tag={model.headingTag} field={model.title} className="subscription-box__content-title" />}
              {model.showForm?.value && (
                <>
                  {model.content && <RichText tag="div" field={model.content} className={'rich-text'} />}
                  <KeepInTouchForm />
                </>
              )}
            </div>
            <div className="subscription-box__social">
              <div className={socialText}>{model.socialMediaTitle && <Text tag="p" field={model.socialMediaTitle} />}</div>
              <div className="subscription-box__social__links-container">
                {model.socialMediaLinks.map((item) => (
                  <SocialLink key={item?.id} item={item} sitecoreContext={props?.sitecoreContext} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LazySection>
  );
};

const SocialLink = (props): JSX.Element => {
  return props.sitecoreContext?.pageEditing ? (
    <>
      <CustomExternalAnchor field={props.item.fields?.link} className="subscription-box__social__link" />
      <EditFrameComponent itemId={props.item.id} fields={[fields.icon]} sitecoreContext={props.sitecoreContext}>
        <Icon iconField={props.item?.fields?.icon} size={iconSize.dsk} color="primary" />
      </EditFrameComponent>
    </>
  ) : (
    <CustomExternalAnchor field={props.item.fields?.link} className="subscription-box__social__link">
      <Icon iconField={props.item.fields?.icon} color="primary" size={iconSize.dsk} />
    </CustomExternalAnchor>
  );
};

const KeepInTouchForm = (): JSX.Element => (
  <form className="subscription-box__form">
    <input type="email" placeholder="E-mail address" className="subscription-box__form-input" />
    <input type="submit" className="subscription-box__form-submit" />
  </form>
);

export default withSitecoreContext()(SubscriptionBox);
